import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import './style.css';

export interface PrivacyPageProps extends RouteComponentProps<{}> {}

export interface PrivacyPageState {
  /* empty*/
}

export class PrivacyPage extends React.Component<
  PrivacyPageProps,
  PrivacyPageState
> {
  render() {
    return (
      <main className="privacy-policy plain-content-page" role="main">
        <h1 className="privacy-policy-header plain-content-page-header">
          Privacy Policy
        </h1>
        <h2>Edge of Play “EOP” Privacy Statement</h2>
        <h3>Your privacy on www.edgeofplay.com</h3>
        <p>
          This Website is administered by “EOP”. The primary purpose of
          edgeofplay.com is to be a dynamic resource and coaching tool. We want
          you to feel secure when visiting our site and are committed to
          maintaining your privacy when doing so.
        </p>
        <p>
          The following provides an overview of how we protect your privacy
          during your visit.
        </p>

        <h3>What information do we gather?</h3>
        <p>
          Information on edgeofplay.com is gathered in two ways: (1) indirectly
          (for example, through our site’s technology); and (2) directly (for
          example, if you fill in a form online).
        </p>
        <p>
          We collect information directly and indirectly through a number of
          ways:
        </p>
        <ul>
          <li>
            Internet access logs. When you access edgeofplay.com, your Internet
            address is automatically collected and is placed in our internet
            access logs.
          </li>
          <li>
            Cookies. Cookies are small files which save and retrieve information
            about your visit to edgeofplay.com – for example, how you entered
            our site, how you navigated through the site, and what information
            was of interest to you. The cookies we use identify you merely as a
            number. (If you are uncomfortable regarding cookies use, please keep
            in mind that you can disable cookies on your computer by changing
            the settings in the preferences or options menu in your browser.)
          </li>
          <li>
            Coach profile. We will collect certain personal information such as
            name, e-mail address and passwords in order to create a coach
            profile on Edge of Play.
          </li>
        </ul>
        <p>
          We may communicate with you through contact information held within
          “EOP” regarding our service so that we can send you news and updates
          about Edge of Play, updates to content, special offers, partnerships
          with other third parties and any promotional announcements. These
          communications may be made through a range of methods such as e-mail,
          text message, social media or push notifications.
        </p>
        <p>
          We may monitor, record, store and use any telephone, email or other
          communication with you in order to check any instructions given to us,
          for training purposes, for crime prevention and to improve the quality
          of our customer service.
        </p>

        <h3>How do we use this information?</h3>
        <p>
          We analyse it to determine what is most effective about our site, to
          help us identify ways to improve it, and eventually, to determine how
          we can tailor www.edgeofplay.com to make it more effective. We may
          also use data for other purposes, which we would describe to you at
          the point we collect the information.
        </p>

        <h3>Disclosure of information</h3>
        <p>
          We disclose your information to third parties for the following
          purposes:
        </p>
        <ul>
          <li>
            Service Providers: In order to facilitate subscription payments we
            use the Stripe Payment Processing platform. Payment details for your
            subscription are securely shared and stored within Stripe. You can
            learn more about Stripe and its privacy policy at{' '}
            <a
              className="edge-of-play-link"
              href="https://stripe.com/privacy"
              target="_blank"
              rel="noopener nofollow"
            >
              https://stripe.com/privacy
            </a>
          </li>
          <li>
            Promotional Offers: We may offer promotions through a “EOP” partner.
            In order for your participation in this promotion we may need to
            share your name and e-mail address information with the partner. Our
            partners are responsible for their own privacy practices.
          </li>
        </ul>

        <h3>What about sensitive personal data?</h3>
        <p>
          We do not generally seek to collect sensitive personal data through
          this site. If we do seek to collect such data, we will ask you to
          consent to our proposed uses of the data. We may also collect some
          sensitive personal data incidentally. By providing us with unsolicited
          sensitive personal data, you consent to our using the data subject to
          applicable law as described in this notice.
        </p>
        <p>
          The references to “sensitive personal data” are to the various
          categories of personal data identified by European and other data
          privacy laws as requiring special treatment, including in some
          circumstances the need to obtain explicit consent. These categories
          comprise personal identity numbers, personal data about personality
          and private life, racial or ethnic origin, colour, nationality,
          political opinions or convictions, membership of political parties or
          movements, religious, philosophical or other similar beliefs, trade
          union membership, physical or mental health or handicap, genetic code,
          addictions, gender, sexual life (including sexual orientation),
          pregnancy, property matters or penal or criminal conviction or record
          (including where a pardon has been granted).
        </p>
        <p>
          While we take steps to maintain the security of edgeofplay.com, you
          should understand that the open nature of the Internet is such that
          data may flow over networks without security measures and may be
          accessed and used by people other than those for whom the data is
          intended.
        </p>

        <h3>Changes to this Privacy Policy</h3>

        <p>
          We may update this Privacy Policy from time to time in response to
          legal, regulatory and operation change, and to ensure that our privacy
          guidelines stay aligned with any changes to the “EOP” website. If any
          changes are made to this policy, we will look to update you, after
          which continued use of the “EOP” website will constitute
          acknowledgement and acceptance of those changes. If you do not wish to
          acknowledge or accept any updates to this Privacy Policy, you may
          cancel subscription to “EOP” at any time.
        </p>

        <p>
          In conclusion we are interested in maintaining your privacy and
          creating a valuable resource for you to use. If you have any questions
          now or during your visit, or if you have any technical difficulties
          using or viewing our website please contact us at{' '}
          <a className="edge-of-play-link" href="mailto:admin@edgeofplay.com">
            admin@edgeofplay.com
          </a>
        </p>
      </main>
    );
  }
}

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/app/containers/PrivacyPage/index.tsx